import { render, staticRenderFns } from "./IconArrowNorth.vue?vue&type=template&id=58227c28"
import script from "./IconArrowNorth.vue?vue&type=script&lang=js"
export * from "./IconArrowNorth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports